import React from 'react';
import { useClassName } from 'common/hooks';
import Center from '../Center';
import useCustomStyle from '../../hooks';
import HomepageAsset from '../Asset';

import './gallery.less';

export default function Gallery({ component }) {
  const classNames = useClassName('CLPGallery');
  const [setRef] = useCustomStyle(component.fields.settings);
  const items = component.fields.items;

  return (
    <Center className={classNames('container')} ref={setRef}>
      {items.slice(0, 6).map((item, i) => (
        <div
          key={item.sys.id}
          className={classNames(['imageWrapper', `item-${i}`])}>
          <HomepageAsset
            asset={item}
            settings={component.fields.settings}
            className={classNames('image')}
          />
        </div>
      ))}
    </Center>
  );
}
